import UserDto from "../accountmodule/UserDto";

class CustomerAgentListDto {
    Id: number;
    Name: string;
    Roles: number;
    CreatedBy: UserDto;
    State: number;
    Token: string;

    constructor(id: number, name: string, roles: number, createdBy: UserDto, state: number, token: string) {
        this.Id = id;
        this.Name = name;
        this.Roles = roles;
        this.CreatedBy = createdBy;
        this.State = state;
        this.Token = token;
    }
}

export default CustomerAgentListDto;
